var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 16,
    fill: "#0A66C2",
    fillOpacity: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 10C37.5507 10 38.3986 10.3512 39.0237 10.9763C39.6488 11.6014 40 12.4493 40 13.3333V36.6667C40 37.5507 39.6488 38.3986 39.0237 39.0237C38.3986 39.6488 37.5507 40 36.6667 40H13.3333C12.4493 40 11.6014 39.6488 10.9763 39.0237C10.3512 38.3986 10 37.5507 10 36.6667V13.3333C10 12.4493 10.3512 11.6014 10.9763 10.9763C11.6014 10.3512 12.4493 10 13.3333 10H36.6667ZM35.8333 35.8333V27C35.8333 25.559 35.2609 24.177 34.2419 23.1581C33.223 22.1391 31.841 21.5667 30.4 21.5667C28.9833 21.5667 27.3333 22.4333 26.5333 23.7333V21.8833H21.8833V35.8333H26.5333V27.6167C26.5333 26.3333 27.5667 25.2833 28.85 25.2833C29.4688 25.2833 30.0623 25.5292 30.4999 25.9668C30.9375 26.4043 31.1833 26.9978 31.1833 27.6167V35.8333H35.8333ZM16.4667 19.2667C17.2093 19.2667 17.9215 18.9717 18.4466 18.4466C18.9717 17.9215 19.2667 17.2093 19.2667 16.4667C19.2667 14.9167 18.0167 13.65 16.4667 13.65C15.7196 13.65 15.0032 13.9468 14.475 14.475C13.9468 15.0032 13.65 15.7196 13.65 16.4667C13.65 18.0167 14.9167 19.2667 16.4667 19.2667ZM18.7833 35.8333V21.8833H14.1667V35.8333H18.7833Z",
    fill: "#EFEFEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 15.5,
    stroke: "white",
    strokeOpacity: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlueIcon);
export default __webpack_public_path__ + "static/media/linkedinBlueIcon.9524e76fc0fe9453c325d984321e5a4e.svg";
export { ForwardRef as ReactComponent };